import { useState } from 'react'
import ModalAlert from '../components/modal/ModalAlert'

function useAlert() {
  const [alert, setAlert] = useState(null)
  const [title, setTitle] = useState(null)
  const [type, setType] = useState(null)

  const showAlert = (title = ' ', message = ' ', type = 'warning') => {
    setTitle(title)
    if (message) setAlert(message)
    setType(type)
  }

  const closeAlert = () => {
    setAlert(null)
    setTitle(null)
    setType(null)
  }

  const AlertComponent = alert && (
    <ModalAlert message={alert} title={title} type={type} onClose={closeAlert} />
  )

  return {
    showAlert,
    AlertComponent,
  }
}

export default useAlert
